(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const saved = new Map();
  let host;
  function restore() {
    for (const [element, properties] of saved) {
      for (const [name, value, priority] of properties) {
        if (value) element.style.setProperty(name, value, priority);
        else element.style.removeProperty(name);
      }
    }
    saved.clear();
  }
  function set(element, properties) {
    saved.set(element, Object.keys(properties).map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]));
    for (const [name, value] of Object.entries(properties)) element.style.setProperty(name, value, 'important');
  }
  function place() {
    restore();
    const button = host?.shadowRoot?.querySelector('[part~="activator"]');
    if (!mobile.matches || !button || button.getAttribute('aria-expanded') === 'true') return;
    set(host, {position: 'relative', inset: 'auto', width: 'auto', height: 'auto', margin: '16px', display: 'block', 'pointer-events': 'auto'});
    set(button.parentElement, {position: 'static', inset: 'auto', transform: 'none', display: 'flex', 'justify-content': 'flex-end'});
  }
  function bind() {
    host = document.querySelector('shopify-chat');
    if (!host?.shadowRoot) return false;
    new MutationObserver(place).observe(host.shadowRoot, {subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded']});
    mobile.addEventListener('change', place);
    place();
    return true;
  }
  if (!bind()) {
    const observer = new MutationObserver(() => { if (bind()) observer.disconnect(); });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }
})();
